module.exports = __webpack_public_path__ + "img/CI.a89552c0.jpg";